/* unplugin-vue-components disabled */import { render } from "./Rating.vue?vue&type=template&id=282f388e&scoped=true&ts=true"
import script from "./Rating.vue?vue&type=script&lang=ts"
export * from "./Rating.vue?vue&type=script&lang=ts"

import "./Rating.vue?vue&type=style&index=0&id=282f388e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-282f388e"]])

export default __exports__